import * as React from 'react';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function fetchTermsAndConditions(contentLink: string) {
    return new Promise<{ title: string, content: string }>((resolve, reject) => {
        const options = {
            method: 'GET',
        };

        fetch(contentLink, options)
            .then((res) => res.json())
            .then(({title, content}) => {
                resolve({title, content});
            });
    });
}

type termsAndConditionsProps = {
    contentLink: string,
    buttonText: string,
    valueNotSelected: boolean
};

export const TermsAndConditions = ({contentLink, buttonText, valueNotSelected}: termsAndConditionsProps) => {
    const [open, setOpen] = React.useState(false);
    const requestAbortController = React.useRef<AbortController | null>(null);
    const [title, setTitle] = React.useState('');
    const [content, setContent] = React.useState('');

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const fetchTermsAndConditionsData = (contentLink: string) => {
        const controller = new AbortController();
        fetchTermsAndConditions(contentLink)
            .then(({title, content}) => {
                setTitle(title);
                setContent(content);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    throw error;
                }
            });

        requestAbortController.current = controller;
    };


    React.useEffect(() => {
        fetchTermsAndConditionsData(contentLink);
        // abort request on unmount
        return () => requestAbortController.current?.abort();
    }, []);

    return (
        <>
            <label className="form-label with-hover" onClick={handleClickOpen}
                   style={valueNotSelected ? {color: 'red'} : {}}>{buttonText}</label>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{m: 0, p: 2}} id="customized-dialog-title">
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        <span dangerouslySetInnerHTML={{__html: content}}/>
                    </Typography>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
